import { render } from "./postNav.vue?vue&type=template&id=06e40faa&scoped=true"
import script from "./postNav.vue?vue&type=script&lang=js"
export * from "./postNav.vue?vue&type=script&lang=js"

import "./postNav.vue?vue&type=style&index=0&id=06e40faa&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e40faa"]])

export default __exports__